    $(function() {

        const swiperGlobalTwo = new Swiper( '.trustpilot .slider', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            loop: true,
            speed: 750,
            navigation: {
                disabledClass: 'disabled',
                prevEl: '.trustpilot .navigation .buttons .button.one',
                nextEl: '.trustpilot .navigation .buttons .button.two',
            },
            pagination: {
                bulletClass: 'icon',
                bulletActiveClass: 'active',
                el: '.trustpilot .pagination .icons',
                dynamicBullets: true,
            },
            breakpoints: {
                0: {
                    spaceBetween: 12,
                    slidesPerView: 1,
                    speed: 500
                },
                600: {
                    spaceBetween: 12,
                    slidesPerView: 2,
                    speed: 500
                },
                900: {
                    spaceBetween: 15,
                    slidesPerView: 3,
                    speed: 750
                },
                1375: {
                    spaceBetween: 16,
                    slidesPerView: 4,
                    speed: 750
                }
            }
        });

        const swiperGlobalThree = new Swiper( '.brands .slider', {
            containerModifierClass: 'slide-',
            slideActiveClass: 'active',
            slideBlankClass: 'blank',
            slideClass: 'slide',
            slideNextClass: 'next',
            slidePrevClass: 'previous',
            slideVisibleClass: 'visible',
            wrapperClass: 'slides',
            loop: true,
            autoplay: {
                delay: 3750,
                disableOnInteraction: false,
            },
            breakpoints: {
                0: {
                    spaceBetween: 0,
                    slidesPerView: 2,
                    speed: 500
                },
                600: {
                    spaceBetween: 0,
                    slidesPerView: 4,
                    speed: 500
                },
                900: {
                    spaceBetween: 0,
                    slidesPerView: 6,
                    speed: 750
                },
                1250: {
                    spaceBetween: 0,
                    slidesPerView: 8,
                    speed: 750
                }
            }
        });

    });
